<template>
  <div>
    <template v-if="actions">
      <v-btn
        small
        v-for="(btn, key) in actions"
        :key="key"
        :color="STATUS[key].color"
        :to="STATUS[key].to"
        @click="handlers[STATUS[key].cb](btn.new_status)"
      >
        {{ btn.name }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { CONST } from '@/utils/index';
import Trial from '@/orm/models/Trial';

const { trial: { META: { PERMISSIONS, STATUS } } } = CONST;

export default {
  name: 'statusActions',
  props: {
    actions: Object,
    permissions: Object,
  },
  data() {
    return {
      PERMISSIONS,
      STATUS,
      handlers: {
        changeStatus: this.onChangeStatus,
      },
    };
  },
  methods: {
    async onChangeStatus(status) {
      if (!status) return;
      try {
        this.setRouteLoadingValue(true);
        const { params } = this.$route;
        const data = await Trial.$update({
          params,
          data: {
            status,
            user_role: this.currentGroup.slug
          },
        });
        await Trial.insertOrUpdate({ data });
      } finally {
        this.setRouteLoadingValue(false);
      }
    },
  },
};
</script>
